import { Col, Row, Skeleton } from "antd"


export const FiltersSkeleton = () => {
    return (
        <>
            <Row wrap align='stretch' justify='center' style={{ rowGap: 10 }}>
                <Col xs={{ span: 12 }} sm={{ span: 8 }} style={{ paddingRight: 15 }} >
                    <Row>
                        <Skeleton.Input active block />
                    </Row>
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 8 }} style={{ paddingRight: 15 }} >
                    <Row>
                        <Skeleton.Input active block />
                    </Row>
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 8 }} style={{ paddingRight: 15 }} >
                    <Row>
                        <Skeleton.Input active block />
                    </Row>
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 8 }} style={{ paddingRight: 15 }} >
                    <Row>
                        <Skeleton.Input active block />
                    </Row>
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 8 }} style={{ paddingRight: 15 }} >
                    <Row>
                        <Skeleton.Input active block />
                    </Row>
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 8 }} style={{ paddingRight: 15 }} >
                
                    <Skeleton.Input active block />

                    <Row align='middle' justify='end' style={{ columnGap: 10, marginTop: 10 }}>
                        <Col span={8}> <Skeleton.Button block active /> </Col>
                        <Col span={8}> <Skeleton.Button block active /> </Col>
                    </Row>
                    
                </Col>
            </Row>
        </>
    )
}